import React, { useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useWindowDimensions } from '../../utils';
import DefaultPage from '../../components/containers/DefaultPage';
import Header from '../../components/blocks/Header';
import Footer from '../../components/blocks/Footer';
import Cookies from "js-cookie";

import { Link, OnestBoldDefault, OnestBoldSmall, OnestNormalDefault, OnestNormalSmall } from "../../components/styled/TextComponents";
import { useNavigate } from "react-router-dom";
import Logo from '../../components/Logo';
import {
    color_white,
    color_red_default,
    color_black,
    color_grey_dark,
    color_grey_ultra_dark,
    color_grey_ultra_light,
    color_grey_light,
    color_green_light,
    color_green
} from '../../constants/colors';
import IconlyCurvedBoldFolder from '../../components/icons/IconlyCurvedBoldFolder';
import IconlyCurvedBoldCalendar from '../../components/icons/IconlyCurvedBoldCalendar';
import ChartIcon from '../../components/icons/ChartIcon';
import IconlyCurvedBold3User from '../../components/icons/IconlyCurvedBold3User';
import { Button } from '../../components/controls/Button/Button';
import Config from '../../Config';
import axios from 'axios';
import moment from 'moment-timezone';
import ModalStartSubscription from '../../components/blocks/ModalStartSubscription';
import { ButtonDefault } from '../../components/controls/Button/ButtonDefault';
import { setUser, updateUser } from "../../store/UserSlice";
import { get_user } from "../../components/blocks/profileUpdating/dataUpdating/ProfileDataUpdatingBlock";
import ModalSendMail from '../../components/blocks/ModalSendMail';
import { useI18n } from '../../i18n/I18nProvider';

export const MOBILE_WIDTH = 1240;

const pageStyles = {
    feachesItem: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        gap: 10,
        height: 44,
    },
    feachesItemText: {
        fontSize: 20,
        color: color_white,
        marginLeft: 12,
    },
    tile: {
        position: "relative",
        borderRadius: 20,
        borderWidth: 1,
        borderStyle: "solid",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "flex-start",
        padding: 20,
        gap: 10,
    }

}





const TariffSelection = () => {
    const { t } = useI18n();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const userData = useSelector((state) => state.user);
    const { height: screenHeight, width: screenWidth } = useWindowDimensions();
    const [tariff, setTariff] = React.useState(null);
    const [PaymentURL, setPaymentURL] = React.useState(null);
    const [isModalSendOpen, setIsModalSendOpen] = React.useState(false);
    const [modalSendMessage, setModalSendMessage] = React.useState("");
    const [modalSendTheme, setModalSendTheme] = React.useState("");


    //проверяем каждые пять секунд срок действия подписки в бд
    useEffect(() => {
        const interval = setInterval(() => {
            if (!PaymentURL) return;
            let backendAddr = Config.BACKEND_ADDR + "/payments/getSubscriptionPeriod" // /api
            axios.get(backendAddr).then(response => {
                if (response.status === 200) {
                    /* 
                    if (response.data.subscriptionPeriod) {
                        const subscriptionPeriod = moment(response.data.subscriptionPeriod).tz(userData.timezone).toDate();
                        const currentTime = moment().tz(userData.timezone);
                        if (moment(currentTime).isBefore(subscriptionPeriod)) {
                            clearInterval(interval);
                            navigate("/billing/");
                        }
                    }
                     */
                    if (response.data.status === "paid") {
                        clearInterval(interval);
                        navigate("/billing/");
                    }
                }
            }).catch(err => {
                console.warn("Ошибка проверки подписки в БД! ", err)
            })
        }, 5000);

        return () => clearInterval(interval);
    }, [PaymentURL]);

    useEffect(() => {
        (async () => {
            try {
                const data = await get_user();
                dispatch(setUser(data));
                if (
                    data.tariff &&
                    (data.tariff === "m" || data.tariff === "y") &&
                    data.paid_until &&
                    typeof data.paid_until === "string" &&
                    data.paid_until.trim() !== ""
                ) {
                    navigate("/billing/");
                }
            } catch (error) {
                console.error('Error fetching user data:', error);
                // Обработка ошибки, например, перенаправление на страницу входа
                navigate('/auth/login');
            }
        })();
    }, [dispatch, navigate]); // Добавлены зависимости

    return (
        <DefaultPage>
            <ModalStartSubscription
                isOpen={!!tariff}
                onClose={() => {
                    setTariff(null);
                    setPaymentURL(null)
                }}
                userData={userData}
                currentTarif={tariff}
                setPaymentURL={setPaymentURL}
            />
            <ModalSendMail
                modalOpen={isModalSendOpen}
                setModalOpen={setIsModalSendOpen}
                email={userData.email}
                phone={userData.phoneNumber}
                message={modalSendMessage}
                theme={modalSendTheme}
            />

            <div style={{
                display: "flex",
                flexDirection: "column",
                //height: screenHeight,
                width: screenWidth,
                //gap: 60,
                justifyContent: "space-between",
                //boxSizing: "border-box",
                overflowX: "hidden"
            }}>

                <div style={{
                    //position: "relative",
                    display: "flex",
                    flexDirection: screenWidth > MOBILE_WIDTH ? "row" : "column",
                    justifyContent: "flex-start",
                    alignItems: "center",

                    gap: screenWidth < 1440 && screenWidth > MOBILE_WIDTH ? 10 : 32,
                }}>
                    <header style={{
                        width: "90%",
                        position: "absolute",
                        top: 30,
                        left: "5%",
                        height: 60,
                        display: "inline-flex",
                        justifyContent: "space-between",
                        alignItems: "flex-end",
                        marginLeft: "auto",
                        marginRight: "auto",
                    }}>
                        <div style={{ cursor: "pointer" }} onClick={() => navigate("/auth/login")}>
                            <OnestBoldDefault style={{ color: color_white, fontSize: 24 }}>
                                SPEAKID
                            </OnestBoldDefault>
                        </div>
                        <div
                            style={{
                                height: 60,
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "flex-end",
                                alignItems: "center",
                                gap: 20
                            }}
                        >
                            <div
                                onClick={() => {
                                    setModalSendMessage(t("Добрый день!\n\nУ меня возникла проблема с оплатой подписки SPEAKID. Помогите, пожалуйста, разобраться.\n\nНомер телефона: ") + userData.phoneNumber + "\n" + t("Email: ") + userData.email);
                                    setModalSendTheme(t("Проблема с оплатой подписки SPEAKID"));
                                    setIsModalSendOpen(true);
                                }}
                            >
                                <OnestNormalDefault
                                    style={{
                                        color: screenWidth > MOBILE_WIDTH ? color_red_default : color_white,
                                        textDecoration: "underline",
                                        cursor: "pointer"
                                    }}
                                >
                                    {t("Помощь")}
                                </OnestNormalDefault>
                            </div>

                            <div
                                onClick={() => {
                                    Cookies.remove('jwt');
                                    navigate("/auth/login")
                                }}
                            >
                                <OnestNormalDefault
                                    //width={145}
                                    style={{
                                        color: screenWidth > MOBILE_WIDTH ? color_red_default : color_white,
                                        textDecoration: "underline",
                                        cursor: "pointer"
                                    }}
                                //height={screenHeight < 660 ? 30 : 40}
                                //active={true}
                                >
                                    {t("Выйти")}
                                </OnestNormalDefault>
                            </div>
                        </div>
                    </header>
                    <div style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        gap: 20,
                        width: screenWidth > MOBILE_WIDTH ? 
                            (screenWidth < 1440 ? 558 - 64 : 595 - 100) 
                            : 
                            screenWidth,
                        height: screenWidth > MOBILE_WIDTH ? screenHeight - 250 : 691,
                        padding: screenWidth > MOBILE_WIDTH ? 
                            (screenWidth < 1440 ? "60px 32px" : "60px 50px") 
                            : 
                            "15px 15px",
                        backgroundImage: `url(${process.env.PUBLIC_URL + "/tariffs.png"})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                    }}>


                        <OnestBoldDefault
                            style={{
                                width: screenWidth > MOBILE_WIDTH ? 494 : screenWidth - 30,
                                fontSize: screenWidth > MOBILE_WIDTH ? (screenWidth < 1440 ? 38 : 48) : 28,
                                textAlign: 'left',
                                marginBottom: 20,
                                color: color_white,
                            }}
                        >
                            {t("Доступ к функционалу")} <br />
                            {t("онлайн-школы,")} <br />
                            {t("работая на себя")}
                        </OnestBoldDefault>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                flexWrap: "wrap",
                                gap: 20,
                                justifyContent: "space-between",
                                width: screenWidth > MOBILE_WIDTH ? 595 : screenWidth - 30,
                            }}
                        >

                            <div style={{
                                ...pageStyles.feachesItem,
                                width: screenWidth > MOBILE_WIDTH ? 287 : screenWidth - 30,
                            }}>
                                <IconlyCurvedBoldFolder width={24} height={24} />
                                <OnestNormalDefault style={pageStyles.feachesItemText}>{t("260+ готовых интерактивных уроков")}</OnestNormalDefault>
                            </div>
                            <div style={{
                                ...pageStyles.feachesItem,
                                width: screenWidth > MOBILE_WIDTH ? 287 : screenWidth - 30,
                            }}>
                                <IconlyCurvedBoldCalendar width={24} height={24} />
                                <OnestNormalDefault style={pageStyles.feachesItemText}>{t("Удобное цифровое расписание")}</OnestNormalDefault>
                            </div>
                            <div style={{
                                ...pageStyles.feachesItem,
                                width: screenWidth > MOBILE_WIDTH ? 287 : screenWidth - 30,
                            }}>
                                <ChartIcon width={24} height={24} />
                                <OnestNormalDefault style={pageStyles.feachesItemText}>{t("Учёт доходов и учеников в одном месте")}</OnestNormalDefault>
                            </div>
                            <div style={{
                                ...pageStyles.feachesItem,
                                width: screenWidth > MOBILE_WIDTH ? 287 : screenWidth - 30,
                            }}>
                                <IconlyCurvedBold3User width={24} height={24} />
                                <OnestNormalDefault style={pageStyles.feachesItemText}>{t("До 30 студентов на одном аккаунте")}</OnestNormalDefault>
                            </div>
                        </div>
                    </div>

                    <div style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "flex-start",
                        gap: screenHeight > 700 ? 20 : 5,
                        width: screenWidth > MOBILE_WIDTH ? ( screenWidth < 1440 ? screenWidth - 558 - 10 : screenWidth - 625 ) : screenWidth,
                        height: screenWidth > MOBILE_WIDTH ? (screenHeight > 700 ? screenHeight - 250 : screenHeight - 140) : "auto",

                    }}>
                        <OnestBoldDefault
                            style={{
                                fontSize: screenWidth > MOBILE_WIDTH && screenHeight > 840 ? 48 : 28,
                                textAlign: 'left',
                                color: color_black,
                                padding: 15,
                            }}
                        >
                            {t("Подписка на платформу")} SPEAK<span style={{ color: color_red_default }}>ID</span>
                        </OnestBoldDefault>
                        <OnestNormalSmall
                            style={{
                                color: color_grey_ultra_dark,
                                padding: 15,
                            }}
                        >
                            {t("Выберите тариф, чтобы начать")} <br />
                            {t("7-дневный пробный период")}
                        </OnestNormalSmall>
                        <div style={{
                            width: screenWidth > MOBILE_WIDTH ? ( screenWidth < 1440 ? screenWidth - 558 - 10 : screenWidth - 595 ) : screenWidth,

                            overflowX: "auto",
                            scrollbarWidth: "none", // For Firefox
                            WebkitOverflowScrolling: "touch", // For smooth scrolling on iOS
                        }}>
                            <div style={{
                                padding: screenWidth > MOBILE_WIDTH ? "15px" : "0 15px",
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "flex-start",
                                alignItems: "center",
                                width: 775,
                                gap: screenWidth < 1366 && screenWidth > MOBILE_WIDTH ? 10 : 20,
                            }}>
                                <div style={{
                                    ...pageStyles.tile,
                                    width: 180,
                                    height: 155,
                                    borderColor: color_grey_light,

                                }}>

                                    <OnestBoldSmall>{t("Месячный план")}</OnestBoldSmall>
                                    <OnestBoldDefault
                                        style={{
                                            color: color_black,
                                            fontSize: 32,
                                        }}
                                    >
                                        1500 ₽ <span style={{ fontSize: 16, color: color_black }}>{t("в месяц")}</span>
                                    </OnestBoldDefault>
                                    <OnestNormalSmall
                                        style={{
                                            color: color_grey_dark,
                                        }}
                                    >({t("18000 ₽ в год")})</OnestNormalSmall>
                                    <Button
                                        color={color_white}
                                        backgroundColor={color_red_default}
                                        height="40px"
                                        width={180}
                                        onClick={() => setTariff("m")}
                                        style={{ borderColor: color_red_default }}
                                    >
                                        {t("Попробовать")}
                                    </Button>
                                </div>
                                <div style={{
                                    ...pageStyles.tile,
                                    width: 225,
                                    height: 170,
                                    borderColor: color_red_default,

                                }}>
                                    <div style={{
                                        position: "absolute",
                                        top: 15,
                                        right: 15,
                                        backgroundColor: color_green_light,
                                        padding: "5px 10px",
                                        borderRadius: 10,
                                    }}>
                                        <OnestBoldSmall style={{ color: color_green }}>-33%</OnestBoldSmall>
                                    </div>

                                    <OnestBoldSmall>{t("Годовой план")}</OnestBoldSmall>
                                    <OnestBoldDefault
                                        style={{
                                            color: color_black,
                                            fontSize: 32,
                                        }}
                                    >
                                        1000 ₽ <span style={{ fontSize: 16, color: color_black }}>{t("в месяц")}</span>
                                    </OnestBoldDefault>
                                    <OnestNormalSmall
                                        style={{
                                            color: color_grey_dark,
                                        }}
                                    >({t("12000 ₽ в год")})</OnestNormalSmall>
                                    <Button
                                        color={color_white}
                                        backgroundColor={color_red_default}
                                        height={40}
                                        width={225}
                                        onClick={() => setTariff("y")}
                                        style={{ borderColor: color_red_default }}
                                    >
                                        {t("Попробовать")}
                                    </Button>
                                </div>
                                <div style={{
                                    ...pageStyles.tile,
                                    width: 180,
                                    height: 155,
                                    borderColor: color_grey_light,

                                }}>

                                    <OnestBoldSmall>{t("Для онлайн-школ")}</OnestBoldSmall>

                                    <OnestNormalSmall
                                        style={{
                                            color: color_grey_dark,
                                        }}
                                    >{t("Индивидуальные условия для школ, поддержка нескольких аккаунтов")}</OnestNormalSmall>
                                    <Button
                                        color={color_white}
                                        backgroundColor={color_red_default}
                                        height="40px"
                                        width={180}
                                        onClick={() => {
                                            setModalSendMessage(t("Добрый день!\n\nМеня интересует подключение платформы SPEAKID для онлайн-школы. Расскажите подробности о возможных условиях сотрудничества.\n\nНомер телефона: ") + userData.phoneNumber + "\n" + t("Email: ") + userData.email);
                                            setModalSendTheme(t("Заявка для онлайн-школы"));
                                            setIsModalSendOpen(true);
                                        }}
                                           
                                        style={{ borderColor: color_red_default }}
                                    >
                                        {t("Оставить заявку")}
                                    </Button>
                                </div>
                            </div>
                        </div>
                        <div style={{ padding: 15 }}>
                            <OnestNormalSmall
                                style={{
                                    color: color_grey_ultra_dark,
                                }}
                            >
                                {t("Сначала 7 дней бесплатно, списание только после")}
                            </OnestNormalSmall>
                            <OnestBoldSmall
                                style={{
                                    color: color_grey_ultra_dark,
                                }}
                            >
                                {t("Отменить можно в любой момент")}
                            </OnestBoldSmall>
                        </div>

                    </div>

                </div>
                {/* 
                {PaymentURL &&
                    <iframe
                        src={PaymentURL}
                        title="Оплата Т-банк"
                        width="100%"
                        height="100%"
                        frameBorder="0"
                        allow="payment"
                        style={{ border: "none", borderRadius: 12, flex: 1 }}
                    />
                } 
                */}
                <Footer />
            </div>
        </DefaultPage>

    )
}

export default TariffSelection